import type {
  GetApiV1ThreeLetterCodePartnerAdminsGroups200,
  GetApiV1ThreeLetterCodePartnerAdminsTopBannersId200,
} from '@fukuri-admins/apis/client/gen/model';
import { EditTopBannerFormPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof EditTopBannerFormPresentation>;
type PresentationPropsWithoutFunctions = Omit<PresentationProps, 'onSubmit' | 'onImageRemove'>;

type IConvertToPresentationProps = (args: {
  /** APIから取得したトップバナーデータ */
  data: GetApiV1ThreeLetterCodePartnerAdminsTopBannersId200;
  /** グループ一覧データ */
  groupsData: GetApiV1ThreeLetterCodePartnerAdminsGroups200;
  /** 既存画像が削除されたかどうか */
  isImageRemoved: boolean;
  /** API実行中フラグ */
  isMutating: boolean;
  /** フォームバリデーションが有効かどうか */
  isFormValid: boolean;
}) => PresentationPropsWithoutFunctions;
/**
 * hooksの状態をプレゼンテーション用のpropsに変換する
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({
  data,
  groupsData,
  isImageRemoved,
  isMutating,
  isFormValid,
}) => {
  // ボタン無効化条件: API実行中 OR フォーム無効 OR 既存画像が削除された
  const isButtonDisabled = isMutating || !isFormValid || isImageRemoved;

  const groupList = groupsData.groups.map(group => ({
    id: String(group.id),
    name: group.name,
    code: group.code,
  }));

  return {
    bannerTitle: data.top_banner.title,
    groupList,
    existingImageUrl: data.top_banner.image.url,
    isButtonDisabled,
  };
};
